import { createSelector } from 'reselect';

export const getCandidate = createSelector(
  (state: any) => state.userCandidates,
  (_: any, id: number) => id,
  (userCandidates, id) => {
    return userCandidates.find((candidate: any) => candidate.id === id);
  }
);

export const getPendingCandidate = createSelector(
  (state: any) => state.pendingCandidates,
  (_: any, id: number) => id,
  (pendingCandidates, id) => {
    return pendingCandidates.find((candidate: any) => candidate.id === id);
  }
);

export const getCandidateInitialValues = (initialValues: any) => {
  return (
    initialValues && {
      city: initialValues.city,
      email: initialValues.email,
      firstName: initialValues.firstName,
      gitHubUrl: initialValues.gitHubUrl,
      lastName: initialValues.lastName,
      linkedInUrl: initialValues.linkedInUrl,
      notes: initialValues.notes,
      phoneNumber: initialValues.phoneNumber,
      portfolioUrl: initialValues.portfolioUrl,
      salary: initialValues.salary,
      firstSkill: initialValues.skills[0],
      secondSkill: initialValues.skills[1],
      thirdSkill: initialValues.skills[2],
      summary: initialValues.summary,
      twitterUrl: initialValues.twitterUrl,
      website: initialValues.website,
      cvUrl: initialValues.cvUrl,
      cvFile: initialValues.cvFile,
    }
  );
};

export const getCandidateData = (formValues: any, status: string) => {
  return {
    city: formValues.city,
    email: formValues.email,
    firstName: formValues.firstName,
    gitHubUrl: formValues.gitHubUrl,
    lastName: formValues.lastName,
    linkedInUrl: formValues.linkedInUrl,
    notes: formValues.notes,
    phoneNumber: formValues.phoneNumber,
    portfolioUrl: formValues.portfolioUrl,
    summary: formValues.summary,
    twitterUrl: formValues.twitterUrl,
    website: formValues.website,
    salary: Number(formValues.salary),
    skills: [formValues.firstSkill, formValues.secondSkill, formValues.thirdSkill],
    status,
  };
};

export const getCandidateNote = createSelector(
  (state: any) => state.notes.candidatesNotes,
  (_: any, id: any) => id,
  (candidatesNotes, id) => candidatesNotes.find((note: any) => note.candidateId === id)
);
